export default __webpack_public_path__ + "fonts/dotted-scratch-PC.svg";